import {
    addResizeListener,
    removeResizeListener
} from "_private/utils/resize-event";

const resizeListener = {
    data() {
        return {
            resizeViewHeight: 0
        };
    },
    methods: {
        getHeightSum(elsHeight, el) {
            return elsHeight + el.offsetHeight;
        },
        resizeListener() {
            const fixedViews = Array.from(document.querySelectorAll(".fixed-view"));
            let fixedViewHeight = 0;
            const containerViews = document.querySelector(".container-view");
            let containerViewHeight = 0;
            fixedViewHeight = fixedViews.reduce(this.getHeightSum, 0);
            containerViewHeight = containerViews.offsetHeight;
            this.resizeViewHeight = containerViewHeight - fixedViewHeight;
        }
    },
    mounted() {
        addResizeListener(this.$refs.pageView, this.resizeListener);
    },
    beforeDestroy() {
        if (this.resizeListener) {
            removeResizeListener(this.$refs.pageView, this.resizeListener);
        }
    }
};

export default resizeListener;
